import React, { ReactNode } from 'react';
import { Title } from './SectionTitle.style';

interface SectionTitleProps {
  children?: ReactNode;
  isOtherProjectDetail?: boolean;
}
const SectionTitle: React.FC<SectionTitleProps> = ({
  children,
  isOtherProjectDetail,
}) => {
  return <Title isOtherProjectDetail={isOtherProjectDetail}>{children}</Title>;
};
export default SectionTitle;
